import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Kpis } from 'src/app/shared/models/kpis.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KpiService {

  constructor(private http: HttpClient) { }

  getKpis(siteId?: string) {
    return this.http.get<Kpis>(`${environment.baseUrl}/admin/indicators/enigme${siteId && !isNaN(+siteId) ? '?siteId=' + siteId : ''}`);
  }
}
